/**
 * O que o painel do Logigate apresenta sozinho, uma vez (ver `@/Logigate/ui/painel/Novidades`):
 * as novidades de 24/10/2026 (a retenção na fonte na FR e o IVA cativo) e os textos do tutorial do
 * casco. As do redesenho (outubro de 2026) já foram vistas e saíram da lista.
 *
 * Para as próximas novidades: troca-se a lista e sobe-se a versão do Logigate em
 * `App\Services\Apresentacao\ApresentacaoDoPainel::VERSOES_NOVIDADES` (quem já viu estas volta a
 * ver as novas; a Escola tem a sua).
 */
import React from "react";
import { Landmark, ReceiptText } from "lucide-react";
import type { DiapositivoNovidade, TextosDoTutorial } from "@/Logigate/ui/painel";

export const NOVIDADES_LOGIGATE: DiapositivoNovidade[] = [
    {
        chave: "retencao-a-receber",
        icone: <ReceiptText />,
        titulo: "Retenção na fonte: o «A receber» é o valor líquido",
        texto: "Numa factura com retenção na fonte, o cliente paga o total menos a retenção e entrega-a ele à AGT. Na FR, as linhas de pagamento cobrem esse valor líquido — o «A receber» —, e o recibo e a conta corrente do cliente usam-no também.",
        destaque: "As facturas de antes de 24/10/2026 ficam como estavam: vê Finanças › Retenções por rever",
    },
    {
        chave: "iva-cativo",
        icone: <Landmark />,
        titulo: "IVA cativo",
        texto: "Marca na ficha do cliente que ele cativa o IVA: o Estado 100%; bancos, seguradoras e operadoras de telecomunicações 50%. A factura aplica-o sozinha e o cliente paga o total menos o IVA cativo.",
        destaque: "Em Clientes › Editar › IVA cativo",
    },
];

export const TUTORIAL_LOGIGATE: TextosDoTutorial = {
    produto: "Logigate",
    boasVindas: "Mostramos-te onde fica cada coisa no painel, em menos de um minuto.",
    seletor: {
        titulo: "A tua empresa",
        texto: "A empresa em que estás a trabalhar. Se geres mais do que uma, em «Trocar» passas para outra.",
    },
    menu: "Os módulos do teu plano: facturação, recursos humanos, finanças e os restantes. Cada grupo abre as suas páginas.",
    fim: "Quando precisares, revê este tutorial e as novidades no menu da tua conta. Bom trabalho!",
};
